interface ArrowRightLinkProps {
  color?: string
}

const ArrowRightLink = ({ color = '#FFEA28' }: ArrowRightLinkProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      stroke={color}
      strokeWidth={1.4}
      d="M2.917 7h8.167m-3.5 3.5 3.5-3.5-3.5-3.5"
    />
  </svg>
)

export default ArrowRightLink
